<template>
  <service-autocomplete
    dense
    @input="handleInputChange"
    :value="value"
    label="Installation"
    :url="url"
    solo
    ref="autocomplete"
    cache-items
    :clearable="!readonly"
    :readonly="readonly"
    v-bind="$attrs"
    id-field="id"
    :search-attributes-array="['code', 'shortname']"
    use-entities
  >
    <template v-slot:item="{ item }">
      {{ item.code }} {{ item.shortname }}
    </template>
    <template v-slot:selection="{ item }">
      {{ item.code }} {{ item.shortname }}
      <v-icon @click="$refs.autocomplete.handleInputRemove">mdi-close</v-icon>
    </template>
  </service-autocomplete>
</template>

<script>
import ServiceAutocomplete from '@/components/selects/ServiceAutocomplete';

export default {
  name: 'PropertySelector',
  components: { ServiceAutocomplete },
  props: {
    value: {
      type: Number,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      url: `${process.env.MYPREDITY_BASE_URI}/properties`,
    };
  },
  methods: {
    handleInputChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>
